module.exports = __webpack_public_path__ + "static/media/stop.a94a5955.svg";